<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VpAdRn/tc-custom/FC-9781528983587.jpg?1684515191930?1709062077374" alt="This image is the cover for the book The Storyteller's Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Storyteller's Child
      </h1>
      <p class="bookDescription body article font2">
        <p>A child's view of her life, framed by her father's romantic tales of Old Ireland and her mother's strong Catholic faith, may not have been considered an ideal upbringing by today's standards. Living in poor tenement housing in a time of war might have been thought of as bleak. Not so, since this story is seen through a child's eyes. Her father's stories and his way of telling them stirred her imagination. These stories never left her while her mother's faith kept her feet on the ground and left a lifelong impression. Her parents had opposing views on the Catholic Church. For her mother, it was a lifeline; for her father, it was something of a joke. This went through their lives without disrupting them. Limited education with this background meant working life for a youngster started at age 14, which would be an eye-opener for a 14-year-old today. It is Christine Brown's unique way of telling the story through a child's eyes which makes it a heartfelt read.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christine Brown
      </h2>
      
      <p class="authorDescription body article">Christine Brown has worked as a journalist on national and regional newspapers and women's magazines. Her first book, Goodbye Patrick, told the story of her five adopted children. Her second book, The Visits, told the story of her visits she made, over the years, to men in one particular prison. She read English literature at St Hilda's College, Oxford, and went on to do her PhD at Reading University. She was born in Edinburgh and now lives in Buckinghamshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b4765e8